export const DOCUMENTS_PAGE_SIZE_OPTIONS = [10, 25, 50];
